import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { compose, lifecycle } from 'recompose';
import { toggleModal as toggleConsentModal } from '../../../store/reducers/modals';
import { UserService } from '../../../services/user-service';
import { withRequiredRedirect } from '../../../components/layout/content/with-required-redirect';
import { withSearchParams } from '../../../helpers/navigation/routing';
import { getRedirectLinkAfterComplete } from '../../../helpers/account';
import { setRedirectionLink } from '../../../store/reducers/navigation';
import { Checkpoint } from '../../checkpoint';
import { withRedirectAfterComplete } from '../hocs/with-redirect-after-complete';

export const AccountCompletePage = React.memo(({ loading, calculatingMsg, metaTitle = 'Complete', to }) => (
  <>
    <Helmet title={metaTitle} />
    <Checkpoint loading={loading} calculatingMsg={calculatingMsg} to={to} />
  </>
));

const SignUpProps = state => {
  const isMarketingPreferences = state.marketingLists.lists.length;

  return {
    calculatingMsg: 'Setting up your account',
    loading:
      isMarketingPreferences && !UserService.hasAccount()
        ? state.account.loadingMarketingListIds
        : state.account.confirming,
    to: withSearchParams('/account/login')
  };
};

const SignInProps = state => ({
  calculatingMsg: 'Logging you in',
  loading: state.account.loggingIn,
  to: getRedirectLinkAfterComplete(state)
});

const ResetPasswordProps = state => ({
  calculatingMsg: 'Resetting password',
  loading: state.account.resettingPassword,
  to: '/account/login'
});

const AccountDetailsProps = state => ({
  calculatingMsg: 'Updating your accounts details',
  loading: state.account.updatingPassword,
  to: '/account'
});

const LogoutProps = state => ({
  calculatingMsg: 'Logging out',
  loading: state.account.loggingOut,
  to: getRedirectLinkAfterComplete(state)
});

const DeleteAccountProps = state => ({
  calculatingMsg: 'Deleting your account',
  loading: state.account.deletingAccount,
  to: '/dashboard'
});

export const SignUpCompletePage = connect(SignUpProps)(AccountCompletePage);
export const SignInCompletePage = compose(
  connect(SignInProps, { setRedirectionLink }),
  lifecycle({
    componentWillUnmount() {
      const { setRedirectionLink } = this.props;

      setRedirectionLink({ link: '' });
    }
  })
)(AccountCompletePage);
export const ResetPasswordCompletePage = connect(ResetPasswordProps)(AccountCompletePage);
export const AccountDetailsCompletePage = connect(AccountDetailsProps)(AccountCompletePage);
export const LogoutCompletePage = compose(
  withRedirectAfterComplete,
  connect(LogoutProps, { setRedirectionLink }),
  lifecycle({
    componentWillUnmount() {
      const { setRedirectionLink } = this.props;

      setRedirectionLink({ link: '' });
    }
  })
)(AccountCompletePage);

export const DeleteAccountCompletePage = compose(
  connect(DeleteAccountProps, { toggleConsentModal }),
  withRequiredRedirect,
  lifecycle({
    componentWillUnmount() {
      this.props.toggleConsentModal(true);
      this.props.processRequiredActivityRedirect();
    }
  })
)(AccountCompletePage);
